import { LexDatePipe } from '../../../../../../../pipes';
import { Widget } from '../../../../../../../providers/bridge-api/dashboard.service';
import { FieldService } from '../../../../../../../providers/storage-api/field.service';
import { Utils } from '../../../../../../../utils/utils';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiSummaryTranslocoParameters } from './widget-ai-insights-summary.service';

export default class NumericMetadataSummaryParameters implements AiSummaryTranslocoParameters {
  constructor(private lexDatePipe: LexDatePipe) {}

  assembleParameters(selectedPoints: any[], widget: Widget<WidgetChartOptions>) {
    let previousScoring;

    return selectedPoints
      .flatMap((p) => p)
      .sort((p1, p2) => p1.category - p2.category)
      .map((p) => {
        const fieldIdx = p.series.chart.series.indexOf(p.series);
        const field =
          widget.payload.numericMetadataFields![fieldIdx] ??
          widget.payload.numericMetadataFields![0];
        const scoring = field.scoring.toLocaleUpperCase();

        let translationKey = `widgets.ai-insights.summary.${widget.payload.type}.${scoring}`;
        translationKey = `${translationKey}.${
          scoring !== previousScoring ? 'first-point' : 'rest-of-points'
        }`;
        previousScoring = scoring;

        return {
          translationKey,
          translationParams: {
            boxSize: field.boxSize,
            fieldName: FieldService.getFieldLongName(field.fieldId),
            date: this.lexDatePipe.transform(p.category, 'long'),
            score: Utils.round(p.y),
          },
        };
      });
  }
}
